import React from 'react';
import { FileText, Calendar, Users, BookOpen } from 'lucide-react';
import FormInput from '../FormInput';

const ExamenGeneralInfo = ({ formData, onInputChange, classes, loading }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
      {/* Header avec icône et gradient */}
      <div className="bg-gradient-to-r from-[#202654] to-[#202654]/90 px-6 py-4">
        <div className="flex items-center text-white">
          <div className="bg-white/10 p-2 rounded-lg mr-3">
            <FileText className="h-6 w-6" />
          </div>
          <div>
            <h2 className="text-lg font-semibold">Informations générales</h2>
            <p className="text-blue-100 text-sm">Définissez les détails de base de l'examen</p>
          </div>
        </div>
      </div>

      {/* Contenu */}
      <div className="p-6 space-y-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Libellé */}
          <div className="lg:col-span-2">
            <FormInput
              label="Libellé de l'examen"
              name="libelle"
              value={formData.libelle}
              onChange={onInputChange}
              placeholder="Ex: Examen Final Semestre 1"
              required
              icon={BookOpen}
            />
          </div>

          {/* Description */}
          <div className="lg:col-span-2">
            <FormInput
              label="Description"
              name="description"
              type="textarea"
              value={formData.description}
              onChange={onInputChange}
              placeholder="Description détaillée de la session d'examen..."
              rows={3}
            />
          </div>

          {/* Classe */}
          <div>
            <FormInput
              label="Classe concernée"
              name="classe"
              type="select"
              value={formData.classe}
              onChange={onInputChange}
              options={[
                { value: '', label: 'Sélectionner une classe' },
                ...(Array.isArray(classes) ? classes.map(classe => ({
                  value: classe.id,
                  label: classe.libelle
                })) : [])
              ]}
              required
              icon={Users}
              disabled={loading}
            />
          </div>

          {/* Statut */}
          <div>
            <FormInput
              label="Statut"
              name="status"
              type="select"
              value={formData.status}
              onChange={onInputChange}
              options={[
                { value: 'PROGRAMME', label: '📅 Programmé' },
                { value: 'EN_COURS', label: '⏳ En cours' },
                { value: 'TERMINE', label: '✅ Terminé' },
                { value: 'ANNULE', label: '❌ Annulé' }
              ]}
              required
            />
          </div>

          {/* Date de début */}
          <div>
            <FormInput
              label="Date de début de la période"
              name="date_debut"
              type="date"
              value={formData.date_debut}
              onChange={onInputChange}
              required
              icon={Calendar}
            />
          </div>

          {/* Date de fin */}
          <div>
            <FormInput
              label="Date de fin de la période"
              name="date_fin"
              type="date"
              value={formData.date_fin}
              onChange={onInputChange}
              required
              icon={Calendar}
            />
          </div>
        </div>

        {/* Info box */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center">
                <span className="text-blue-600 text-sm">💡</span>
              </div>
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-blue-800">Information</h3>
              <p className="text-sm text-blue-700 mt-1">
                Les dates de début et fin définissent la période globale pendant laquelle l'examen peut avoir lieu. 
                Vous pourrez ensuite définir les sessions spécifiques dans la section suivante.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExamenGeneralInfo; 